import React, { Component } from 'react';
import FilterStepTitle from './FilterStepTitle';
import Filter from './Filter';

class FilterStep extends Component {
	constructor(props) {
		super(props);

		this.state = {
			number: this.props.step.number
		}

		this.handleFilterChange = this.handleFilterChange.bind(this);
	}
	handleFilterChange(id) {
		this.props.onStepChange(id, this.state.number);
	}
	render() {
		var step         = this.props.step;
		var title        = (typeof(step.title) === 'undefined') ? '' : step.title;
		var classes      = ['filters__step'];
		var prevStepNum  = step.number - 1;
		var prevChosenId = this.props.chosenIds[prevStepNum];

		// Decide whether to show this step
		if (typeof(prevChosenId) !== 'undefined' && ('parentId' in step && prevChosenId === step.parentId))
		{
			classes.push('filters__step--show');
		}

		return (
			<div className={classes.join(' ')}>

				<FilterStepTitle text={title} />

				<ul className="filters__items">
					
					{step.filters.map((filter, index) =>
					<li key={filter.id} className="filters__item">

						<Filter id={filter.id} name={filter.name} stepChosenId={step.chosenId} onFilterChange={this.handleFilterChange} />

					</li>
					)}

				</ul>

			</div>
		);
	}
}

export default FilterStep;
